// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3EMPf","container":"styles_container__1VpLg","title":"styles_title__Ry_xQ","wrapper":"styles_wrapper__11yoG","answer":"styles_answer__3W-xM"};